import React from 'react';
import FooterSiteMap from './footerSiteMap/FooterSiteMap';
import Glossary from './glossary/Glossary';
import A from './glossary/A';
import Ka from './glossary/Ka';
import Sa from './glossary/Sa';
import Ta from './glossary/Ta';
import Na from './glossary/Na';
import Ha from './glossary/Ha';
import Ma from './glossary/Ma';
import Ya from './glossary/Ya';
import Ra from './glossary/Ra';
import Wa from './glossary/Wa';

function App() {
  return (
    <FooterSiteMap/>
  );
}

export default App;
